import type { RootState } from 'store/configureStore';

import type { Collaborator, Collaborators } from './types';

type ModalStatus = {
  isOpened: boolean;
};

const getScope = (state: RootState) => state.modules.quotes.collaborators;

export const getCollaborators = (state: RootState): Collaborators =>
  getScope(state).list;

export const getCollaboratorCount = (state: RootState): number =>
  new Set(Object.values(getCollaborators(state)).map((x) => x.id)).size;

export const getCollaboratorByQuoteItemId = (
  state: RootState,
  quoteItemId: number,
): Collaborator | null => getCollaborators(state)[quoteItemId] || null;

export const getModalStatus = (state: RootState): ModalStatus =>
  getScope(state).modalStatus;

export const getQuoteItemHasCollaborator = (
  state: RootState,
  quoteItemId: number,
): boolean => !!getCollaboratorByQuoteItemId(state, quoteItemId);
